export const SET_PROFILE = 'SET_PROFILE';

export function setProfile(profile) {
  return {
    type: SET_PROFILE,
    profile
  };
}



// WEBPACK FOOTER //
// ./src/actions/profile.js